import { render, staticRenderFns } from "./xmltiss.vue?vue&type=template&id=7570d07d&"
import script from "./xmltiss.vue?vue&type=script&lang=js&"
export * from "./xmltiss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports